import { faBuildingColumns, faCreditCard, faMoneyBillWave } from "@fortawesome/pro-solid-svg-icons";
import MastercardSvg from "@/components/landing/Payments/svg/MastercardSvg";
import VisaSvg from "@/components/landing/Payments/svg/VisaSvg";
import { Icon } from "@/components/ui/Icon";

interface PaymentMethodMarkProps {
	id: string;
	size?: number;
}

/** Maps a payment-method id (from CMS/i18n content) to a recognizable mark or icon. */
function PaymentMethodMark(prop: PaymentMethodMarkProps) {
	const { id, size = 18 } = prop;
	if (id === "card") {
		return (
			<span className="flex items-center ">
				<VisaSvg className="h-3" />
				<MastercardSvg className="h-4" />
			</span>
		);
	}
	if (id === "cod") return <Icon icon={faMoneyBillWave} size={size} />;
	if (id === "bank") return <Icon icon={faBuildingColumns} size={size} />;
	return <Icon icon={faCreditCard} size={size} />;
}

export default PaymentMethodMark;
